<template>
    <div>
      <v-row align="center" class="pa-4">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="$checkPermission('create_key')"
                  icon
                  class="mt-3"
                  v-bind="attrs"
                  v-on="on"
                >
                <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
            </template>
            <v-list width="300" dense>
              <v-list-item v-if="$checkPermission('create_key')" @click.prevent="newKeyDialog = true">
              <v-list-item-title>Создание ключа, привязка к калитке</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="$checkPermission('import_keys_gate')" @click.prevent="popupImport = true">
                <v-list-item-title>Загрузить ключи ИЗ устройства</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="$checkPermission('export_keys_gate')" @click.prevent="popupExport = true">
                <v-list-item-title>Загрузить ключи В устройство</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div>
            <BaseTextField
              v-model="filterName"
              :is-button="false"
              icon="mdi-magnify"
              label="Введите код ключа"
            />
          </div>
          <v-spacer></v-spacer>
          <v-dialog v-model="newKeyDialog" max-width="900" content-class="dialog-border-radius">
            <NewKeyModal
              :active.sync="newKeyDialog"
              @close="newKeyDialog = false"
              header="Продажа ключей от калитки (колясочная)"
              header-mobile="Продажа ключей"
              icon="mdi-account-key-outline"
              @submit="getData()"
              :basic-info-devices="basicInfoGates"
            />
          </v-dialog>
        <v-tooltip bottom v-if="$checkPermission('delete_keys_by_csv_gate')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#B81B1B"
              class="border card-footer-button mt-1 mb-2"
              v-bind="attrs"
              v-on="on"
              @click.prevent="getPopupTask('delet')"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>Удалить ключи csv</span>
        </v-tooltip>
        <v-tooltip bottom v-if="$checkPermission('import_from_csv_keys_gate')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#85B285"
              class="border card-footer-button mt-1 mb-2"
              v-bind="attrs"
              v-on="on"
              @click.prevent="getPopupTask('import')"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-application-import</v-icon>
            </v-btn>
          </template>
          <span>Добавить ключи csv</span>
        </v-tooltip>
        <v-tooltip bottom v-if="$checkPermission('update_gate')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#4C6C93"
              class="border card-footer-button mt-1 mb-2"
              v-bind="attrs"
              v-on="on"
              @click.prevent="downloadReportPage()"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
            </v-btn>
          </template>
          <span>Скачать отчёт</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#4C6C93"
              class="border card-footer-button mt-1 mb-2"
              v-bind="attrs"
              v-on="on"
              @click="getData"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>Обновить</span>
        </v-tooltip>
      </v-row>
      <v-data-table
        class="table"
        :headers="headersKeys"
        :items="filteredKeys()"
        :items-per-page="20"
        :footer-props="{
            'items-per-page-options': [10, 20, 30],
            showFirstLastPage: true
        }"
        sort-by="id"
      >
      <template v-slot:item.universal="{ item }">
        <span v-if="item.universal === 1">Да</span>
        <span v-else>Нет</span>
      </template>
      <template v-slot:item.actions="{ item }">
          <v-row justify="center">
          <v-tooltip v-if="$checkPermission('detach_key_gate')" bottom>
              <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                tile
                small
                class="btn__icon pa-0 mr-3"
                width="18"
                color="#8B939E"
                height="18"
                v-bind="attrs"
                v-on="on"
                @click.stop="$set(dialogDetachKey, item.id, true)"
              >
                <v-icon class="action-icon">
                  mdi-link-variant-remove
                </v-icon>
              </v-btn>
              </template>
              <span>Отвязать</span>
          </v-tooltip>
            <v-dialog v-model="dialogDetachKey[item.id]" max-width="350">
              <baseDeleteModal
                :active.sync="dialogDetachKey[item.id]"
                @close="$set(dialogDetachKey, item.id, false)"
                @submit="detachKeyBtn(item.id)"
                messageTitle="Отвязать ключ?"
                messageText="Подтверждая, вы отвяжите ключ от калитки."/>
            </v-dialog>
          <v-tooltip v-if="$checkPermission('destroy_key')" bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              text
              tile
              small
              class="btn__icon pa-0"
              width="18"
              color="#8B939E"
              height="18"
              v-bind="attrs"
              v-on="on"
              @click.stop="$set(dialogDeleteKey, item.id, true)"
            >
              <v-icon class="action-icon">
                mdi-close
              </v-icon>
            </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
          <v-dialog v-model="dialogDeleteKey[item.id]" max-width="350">
            <baseDeleteModal
              :active.sync="dialogDeleteKey[item.id]"
              @close="$set(dialogDeleteKey, item.id, false)"
              @submit="deleteKeyBtn(item.id)"
              messageTitle="Удалить ключ?"
              messageText="Подтверждая,вы удалите ключ от калитки."/>
          </v-dialog>
        </v-row>
      </template>
      </v-data-table>
      <v-dialog v-model="popupImport" max-width="400">
        <v-card>
          <v-card-title class="headline justify-center">Импорт</v-card-title>
          <v-card-text class="pb-2">Загрузить (импортировать) список ключей из устройства в бд (личный кабинет)?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" text @click.prevent="popupImport = false">Отменить</v-btn>
            <v-btn color="success darken-1" text  @click.prevent="importKeys()" :loading="isUpdatedImport">Загрузить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="popupExport" max-width="400">
        <v-card>
          <v-card-title class="headline justify-center">Экспорт</v-card-title>
          <v-card-text>Загрузить (экспортировать) список ключей из бд (личный кабинет) в устройство?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" text @click.prevent="popupExport = false">Отменить</v-btn>
            <v-btn color="success darken-1" text  @click.prevent="exportKeys()" :loading="isUpdatedExport">Загрузить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="popupTaskKeys"
        max-width="480"
        lazy-validation
        persistent
        content-class="dialog-border-radius"
      >
      <v-card>
        <v-card-title class="headline justify-center">{{ nameTask }}</v-card-title>
          <v-col cols="11" class="py-0">
          <v-file-input
              v-model='taskKeysFile'
              accept=".csv"
              outlined
              dense
              flat
              label="Ключи"
              :rules="[
              value => !!value || 'Обязательное поле',
              ]"
          ></v-file-input>
          </v-col>
          <v-card-actions>
          <div class="mx-auto">
            <v-btn
            large
            class="ma-2 text-none"
            outlined
            dense
            hide-details
            color="error"
            @click.prevent="closePopupTaskKeys()"
            >
            Отменить
            </v-btn>
            <v-btn
              large
              color="success"
              class="text-none"
              dense
              :loading="loadingTask"
              @click.prevent="taskKeys()"
            >
              Применить
            </v-btn>
          </div>
          </v-card-actions>
      </v-card>
      </v-dialog>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { headersKeys } from '../../consts';
import NewKeyModal from '@/components/gate/DetailGate/components/NewKeyModal';
import baseDeleteModal from '@/components/BaseDeleteModal';
import cp1251Encode from '@/mixins/cp1251Encode';
import BaseTextField from '../../../BaseTextField';

export default {
  name: 'Keys',
  mixins: [cp1251Encode],
  components: { NewKeyModal, baseDeleteModal, BaseTextField },
  props: {
    getData: Function,
  },
  data () {
    return {
      headersKeys,
      filterName: '',
      searchCode: '',
      nameTask: '',
      dialogDetachKey: {},
      dialogDeleteKey: {},
      validKey: true,
      newKeyDialog: false,
      isUpdatedImport: false,
      isUpdatedExport: false,
      unbindDuplicate: false,
      freeDuplicate: true,
      importDuplicate: false,
      popupTaskKeys: false,
      popupImport: false,
      popupExport: false,
      taskKeysFile: null,
      freeKeyId: '',
      taskParam: '',
      loadingTask: false,
      universal: false,
    };
  },

  computed: {
    ...mapGetters({
      gate: 'Gate/gate',
    }),
    basicInfoGates () {
      return [
        { label: 'Калитка', value: ` № ${this.gate.id}`, check: '1' },
        { label: 'Город', value: this.gate.address.split(' ')[0], check: this.gate.address },
        { label: 'Район', value: this.gate.region_name, check: this.gate.region_name },
        { label: 'Адрес', value: this.gate.address, check: this.gate.address },
      ];
    },
  },
  methods: {
    ...mapActions({
      getGate: 'Gate/getWebInfoGate',
      addKey: 'Gate/addKey',
      getImportKeysGate: 'Gate/getImportKeysGate',
      getDestroyKeysGate: 'Gate/getDestroyKeysGate',
      importKeysFromDevice: 'Gate/importKeysFromDevice',
      exportKeysToDevice: 'Gate/exportKeysToDevice',
      removeKeyGate: 'Gate/removeKeyGate',
      detachKeyGate: 'Gate/detachKeyGate',
    }),
    filteredKeys () {
      if (this.filterName) {
        return this.gate.keys.filter(key =>
          key.code.toLowerCase().includes(this.filterName.toLowerCase()),
        );
      } else {
        return this.gate.keys;
      }
    },
    getPopupTask (param) {
      this.popupTaskKeys = true;
      if (param === 'import') {
        this.taskParam = 'import';
        this.nameTask = 'Добавление ключей через csv файл';
      } else {
        this.taskParam = 'delet';
        this.nameTask = 'Удаление ключей через csv файл';
      }
    },
    taskKeys () {
      if (this.taskParam === 'import') {
        this.getImportKeys();
      } else {
        this.deleteKeys();
      }
    },
    importKeys () {
      this.isUpdatedImport = true;
      this.importKeysFromDevice({
        id: this.$route.params.id,
      })
        .then(() => {
          this.$flash_success('Ключи загружены ИЗ устройства!');
          this.getData();
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка загрузки ключей');
          }
        })
        .finally(() => {
          this.popupImport = false;
          this.isUpdatedImport = false;
        });
    },
    exportKeys () {
      this.isUpdatedExport = true;
      this.exportKeysToDevice({
        id: this.$route.params.id,
      })
        .then(() => {
          this.$flash_success('Ключи загружены В устройство!');
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка загрузки ключей');
          }
        })
        .finally(() => {
          this.popupExport = false;
          this.isUpdatedExport = false;
        });
    },
    detachKeyBtn (idKey) {
      this.detachKeyGate({
        gateId: this.$route.params.id,
        keyId: idKey,
      })
        .then(() => {
          this.$flash_success('Ключ отвязан');
          this.dialogDetachKey[idKey] = false;
          this.getData();
        })
        .catch((message) => {
          if (message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при отвязке ключа');
          }
          this.dialogDetachKey[idKey] = false;
        });
    },
    deleteKeyBtn (idKey) {
      this.removeKeyGate({
        gateId: this.$route.params.id,
        keyId: idKey,
      })
        .then(() => {
          this.$flash_success('Ключ удалён');
          this.dialogDeleteKey[idKey] = false;
          this.getData();
        })
        .catch((message) => {
          if (message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при удалении ключа');
          }
          this.dialogDeleteKey[idKey] = false;
        });
    },
    downloadReportPage () {
      const lines = [];
      this.gate.keys.forEach((item) => {
        const line = [
          item.id, item.name, item.code, item.serial_number, item.comment,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'Keys-gate.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    closePopupTaskKeys () {
      this.popupTaskKeys = false;
      this.taskKeysFile = null;
    },
    getImportKeys () {
      const formData = new FormData();
      formData.append('keys', this.taskKeysFile);
      this.loadingTask = true;
      this.popupTaskKeys = false;
      this.getImportKeysGate({
        id: this.$route.params.id,
        formData,
      })
        .then(() => {
          this.taskKeysFile = null;
          this.popupDeleteKeys = false;
          this.$flash_success('Ключи добавлены!');
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при добалвении ключей');
        })
        .finally(() => {
          this.loadingTask = false;
        });
    },
    deleteKeys () {
      const formData = new FormData();
      formData.append('keys', this.taskKeysFile);
      this.loadingTask = true;
      this.popupTaskKeys = false;
      this.getDestroyKeysGate({
        id: this.$route.params.id,
        formData,
      })
        .then(() => {
          this.taskKeysFile = null;
          this.$flash_success('Ключи удалены');
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка удаления ключей');
        })
        .finally(() => {
          this.loadingTask = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-radius: 16px;
}
.keys-title {
  display: block;
  padding: 14px 10px 10px;
}
.key-filter {
  display: flex;
  flex-direction: row;
}
.input {

  &-search {
    max-width: 301px;
    width: 100%;
  }
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.text-dialog {
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
}
.action-icon {
  width: 18px !important;
  height: 18px !important;
  font-size: 18px !important;
}
.action-column {
  margin: auto;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 600px) {
  .action-column {
    display: inline-grid !important;
  }
}
</style>
